import React from 'react';
import VBControlEnd from './vbControlEnd';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import styled from 'styled-components';

import { CssInput } from './vbCssComponents';

const PhoneInputWrapper = styled.div`
  .vb-phone-input {
    background-color: ${props => props.variant === 'light' && '#fff !important'};
    padding-left: 20px;
    border-radius: 8px;

    & input {
      color: ${props => props.variant === 'light' && '#000 !important'};
      border: ${props => props.variant === 'light' && '0px'};
      border-radius: 8px;
    }
  }
  
`;

class VBPhoneInput extends React.Component {
    constructor(props){
        super();

        {/* we use our own input component to maintain control over css classes applied to the input*/}
        this.forwardInput = React.forwardRef((props, ref) => {
            return <CssInput {...props} ref={ref} className={this.props.inputClass + this.setValidation()} style={Object.assign({paddingRight: this.state.paddingRight}, this.props.inputStyle)} />;
        });

        this.state={
            value:props.initial ? props.initial : "",
            error: null,
            hasBlurred: false,
            paddingRight: null
        }
        
        this.controlEnd = React.createRef();
        this.input = React.createRef();
        this.label = React.createRef();
    }

    componentDidMount(){
        //Update the padding on the input to allow any length of suffix
        this.setState({ paddingRight: this.controlEnd.current.getWidth(), labelHeight: this.label.current.clientHeight });
    }

    onChange(val){
        this.setState({
            value:val
        });
        if(this.props.onChange){
            this.props.onChange(val);
        }
    }

    onFocus(e){

        this.setState({hasBlurred: false})
        
        if(this.props.onFocus){
            this.props.onFocus(e);
        }
    }

    onBlur(e){
        let error = ""
        //If validation returns a string its an error message, if null the validation passed
        if(this.props.validation){
            error = this.props.validation(this.state.value)
        }
        this.setState({
            error:error,
            hasBlurred:true
        });
        if(this.props.onBlur){
            this.props.onBlur(e);
        }
    }

    setValidation(){
        //Only show validation styling if the user has left the input and there is something to validate with
        if(this.props.error) { return " validation-failed"; }
        if(!this.props.validation || !this.state.hasBlurred) { return ""; }
        if(this.state.error) { return " validation-failed"; }
        if(this.state.value != "") { return " validation-ok"; }
        return "";
    }

    getSuffixClass(){
        return this.props.suffix ? "vb-suffix" : "";
    }


    render() {
        return (
            <div className="vb-input-container block">
                <div ref={this.label} onClick={() => {this.input.current.focus()}}>
                    {this.props.label}
                </div>
                <PhoneInputWrapper 
                    className="vb-control-container w-full inline-block relative"
                    variant={this.props.variant}
                >
                    <PhoneInput 
                        ref={this.input}
                        placeholder={this.props.placeholder}
                        labelHeight={this.state.labelHeight+'px'}
                        inputComponent={this.forwardInput}
                        defaultCountry="SE"
                        value={this.state.value}
                        onChange={this.onChange.bind(this)}
                        onBlur={this.onBlur.bind(this)}
                        onFocus={this.onFocus.bind(this)}
                        disabled={this.props.disabled}
                        className={"vb-phone-input"}
                    />
                    <VBControlEnd ref={this.controlEnd} suffix={this.props.suffix} icon={this.setValidation()}/>
                </PhoneInputWrapper>
                <div className="supp-scarlet caption pt-1">
                    {this.props.error ? this.props.error : null}
                    {this.state.hasBlurred && !this.props.error ? this.state.error : null}
                </div>
            </div>
            
        );
    }
}

VBPhoneInput.defaultProps = { 
    inputClass: '',
    variant: 'dark'
};

export default VBPhoneInput;